<template>
    <div style="border-bottom:1px solid #e8e8e8;padding: 5px 0">
        <img @click="goBack" src="../../assets/img/pos/back.png">
    </div>
</template>

<style>

</style>


<script>

    export default {
        data() {
            return {

            };
        },
        props: {

        },
        mounted() {

        },
        methods: {
          goBack(){
              router.push('card_qrcode')
          }
        }
    }
</script>



// WEBPACK FOOTER //
// topbar.vue?5e59e691